import { prepareChessboard } from "../../utils";
import $ from 'jquery';

/**
* @name preAssessmentBoard1
* @function
* @param {config}
* @description: Highlight Knights Move
*/

export function preAssessmentBoard1(config) {
    let squares = config.squares;

    let afterLoad = function () {
        prepareChessboard(config);
        squares.forEach(square => {
            $(square).prepend('<img class="blue-star" src="img/blue-star.png" />')
        })
    }
    const chessConfig = {
        config: {
            position: config.position,
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name preAssessmentBoard2
 * @function
 * @param {config}
 * @description: Hide coordinates
 */

export function preAssessmentBoard2(config) {
    let squares = config.squares;

    let afterLoad = function () {
        prepareChessboard(config);

        squares.forEach(square => {
            $(square).css('background-color', '#F9F4ED').css('border', '1px solid #6DA3D9');
        });
    }
    const chessConfig = {
        config: {
            position: config.position,
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/pre-assessment/assignments.js